import { Popover } from 'antd'
import { CommentsContent } from './components'
import PropTypes from 'prop-types'

const Comments = ({
  children,
  hasComment,
  onClick,
  comments,
  setData,
  loading,
  onRefetchComments,
  onCommentCreate,
  onCleanHasComment,
}) => {
  return (
    <Popover
      visible={hasComment}
      trigger="click"
      destroyTooltipOnHide={true}
      placement="topRight"
      onVisibleChange={(visible) => onClick(visible)}
      content={
        <div
          style={{ width: '100%', cursor: 'pointer' }}
          onClick={(e) => e.stopPropagation()}
          role="button"
          tabIndex={0}
          onTouchStart={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.stopPropagation()
            }
          }}
        >
          <CommentsContent
            data={comments}
            setData={setData}
            onCommentCreate={onCommentCreate}
            onRefetchComments={onRefetchComments}
            loading={loading}
            onCleanHasComment={onCleanHasComment}
          />
        </div>
      }
    >
      {children}
    </Popover>
  )
}

Comments.propTypes = {
  children: PropTypes.node,
  hasComment: PropTypes.any,
  onClick: PropTypes.func,
  comments: PropTypes.array,
  setData: PropTypes.func,
  loading: PropTypes.bool,
  onRefetchComments: PropTypes.func,
  onCommentCreate: PropTypes.func,
  onCleanHasComment: PropTypes.func,
}

export default Comments
